import React from "react";
import { IMeasurementProperties } from "../../models/measurement/InstrumentDetails";
import ValueRangeStatus from "./ValueRangeStatus";
import * as CONSTANTS from "../../utilities/Constants";

class Utility {
    public sortAlphaNum = (a: any, b: any) => {
        var reA = /[^a-zA-Z]/g;
        var reN = /[^0-9]/g;

        if (!isNaN(a.positionName)) {
            var aA = a.positionName.replace(reA, "");
            var bA = b.positionName.replace(reA, "");

            if (aA === bA) {
                var aN = parseInt(a.positionName.replace(reN, ""), 10);
                var bN = parseInt(b.positionName.replace(reN, ""), 10);
                return aN === bN ? 0 : aN > bN ? 1 : -1;
            } else {
                return aA > bA ? 1 : -1;
            }
        }
    }

    public not_Allow_Char_in_UserName = (value: string): boolean => {
        const specials = /[*\\|"/:?<>]/;
        if (specials.test(value)) {
          return true;
        }
        return false;
      };

    public getValueRange = (value: number, limits: any) => {
        if ((limits.RejectHigh != null && value > limits.RejectHigh) || (value < limits.RejectLow && limits.RejectLow != null))
                return ValueRangeStatus.Reject;
            else if (((value > limits.AlarmHigh1 && limits.AlarmHigh1 != null) && (value < limits.AlarmHigh2 && limits.AlarmHigh2 != null))
                || ((value < limits.AlarmLow1 && limits.AlarmLow1 != null) && (value > limits.AlarmLow2 && limits.AlarmLow2 != null)))
                return ValueRangeStatus.Limit1;
            else if (((value > limits.AlarmHigh2 && limits.AlarmHigh2 != null) && (value < limits.RejectHigh && limits.RejectHigh != null))
                || ((value < limits.AlarmLow2 && limits.AlarmLow2 != null) && (value > limits.RejectLow && limits.RejectLow != null) ))
                return ValueRangeStatus.Limit2;
            
        return ValueRangeStatus.WithinLimit;
    }
    public getUniquePropertiesFromList = (properties: IMeasurementProperties[]) =>{
        const uniqueArray = properties.map((i) => {
            i.uniqueKey = `${i.name}-${i.id}-${i.directionId}`
            return i;
        })
        const filteredProps = [];
        const map = new Map();
        for (const item of uniqueArray) {
            if (!map.has(item.uniqueKey)) {
                map.set(item.uniqueKey, true);
                filteredProps.push(item);
            }
        }
        return filteredProps;
    }
    public removeDuplicatefromArray = (array: any) => {
        let filteredArray = [];
        filteredArray = array?.filter((obj: any, index: any) => {
            return index === array.findIndex((i:any) => obj.value === i.value)
        })
        return filteredArray;
    }

    public removeDuplicatefromArrayBasedOnId = (array: any) => {
        let filteredArray = [];
        filteredArray = array?.filter((obj: any, index: any) => {
            return index === array.findIndex((i:any) => obj.id === i.id)
        })
        return filteredArray;
    }

    public removeDuplicatefromArrayBasedOncustomId = (array: any) => {
        let filteredArray = [];
        filteredArray = array?.filter((obj: any, index: any) => {
            return index === array.findIndex((i:any) => obj.customId === i.customId)
        })
        return filteredArray;
    }

    public pickTextColorBasedOnBgColorAdvanced = (bgColor:string, lightColor:string, darkColor:string) => {
        if(bgColor === CONSTANTS.WITHIN_LIMIT_BG_COLOR){
            return darkColor
        } else {
            var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            var uicolors = [r / 255, g / 255, b / 255];
            var c = uicolors.map((col) => {
                if (col <= 0.03928) {
                return col / 12.92;
                }
                return Math.pow((col + 0.055) / 1.055, 2.4);
            });
            var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
            return (L > 0.339) ? darkColor : lightColor;
        }
    }

    public getLocalDateTime(datetime:any){
        let utc = new Date(datetime);
        let offset = utc.getTimezoneOffset();
        return new Date(utc.getTime() - offset * 60000)
    }
}

const utility = new Utility();
export default utility;